<template>
	<div class="animated fadeIn">
		<b-tabs v-model="activeTab">
			<b-tab title="Информация">
				<div class="card">
				<div class="card-header">Мероприятие: <strong>{{ data.product.title }}</strong>
					<!-- <a class="btn btn-sm btn-info float-right" href="#"><i class="fa fa-edit"></i> редактировать</a> -->
				</div>
				<div class="card-body">
					<div class="row">
						<div class="col-sm-6">
							<dl>
								<dt>Заголовок:</dt>
								<dd>{{ data.product.title }}</dd>
								<dt>Описание:</dt>
								<dd>{{ data.product.description }}</dd>
								<dt>Дата начала:</dt>
								<dd>{{ dateFormat(data.start_at) }}</dd>
								<dt>Продолжительность (дней):</dt>
								<dd>{{ data.duration }}</dd>
							</dl>
						</div>
					</div>
				</div>
				</div>
			</b-tab>

			<b-tab title="Участники" class="product-members">
				<div class="row">
					<div class="col-md-6">
						<ul class="info-list no-style">
							<li class="info-list__item"><span class="badge badge-primary">{{ totalPayments }}</span>Всего сделок</li>
							<li class="info-list__item"><span class="badge badge-primary">{{ totalMembers }}</span>Всего участников</li>
							<li class="info-list__item"><span class="badge badge-primary bg-pink">{{ counter.vip }}</span>VIP</li>
							<li class="info-list__item"><span class="badge badge-success bg-blue">{{ counter.business }}</span>Бизнес</li>
							<li class="info-list__item"><span class="badge badge-dark">{{ counter.standard }}</span>Стандарт</li>
						</ul>
					</div>
					<div class="col-md-6">
						<div class="float-right">
							<b-button variant="primary" @click="onToggleFilter" class="filter-visibility-trigger" :class="{ 'open': isFilterOpen }">Фильтр</b-button>
							<b-button variant="primary" @click="actionExport"><i class="icon-cloud-download"></i> Экспорт в Excel</b-button>
						</div>
					</div>
				</div>
				<div class="filter-container mb-3">
					<product-member-filter :isFilterOpen="isFilterOpen" @send="onSendFilterForm"></product-member-filter>
				</div>
				<vuetable ref="vuetable"
					:fields="columns"
					:api-mode="false"
					:data="tableData"
					@vuetable:cell-dblclicked="rowClickHandler"
					@vuetable:pagination-data="onPaginationData"
					class="event-members table-striped"
					noDataTemplate="Ничего не найдено"
				>
					<template slot="id" slot-scope="props">
						<router-link :to="'/payments/details/' + props.rowData.id + '/update'" target="_blank">{{ props.rowData.id }}</router-link>
					</template>
					<template slot="bitrix_deal_id" slot-scope="props">
						<a :href="'https://legalbis.bitrix24.ru/crm/deal/details/' + props.rowData.bitrix.deal_id + '/'" target="_blank">{{ props.rowData.bitrix.deal_id }}</a>
					</template>
					<template slot="bitrix_company_id" slot-scope="props">
						<a :href="'https://legalbis.bitrix24.ru/crm/company/details/' + props.rowData.bitrix.company_id + '/'" target="_blank">{{ props.rowData.bitrix.company_id }}</a>
					</template>
					<template slot="manager" slot-scope="props">
						{{ props.rowData.manager.first_name + ' ' + props.rowData.manager.last_name }}
					</template>
					<template slot="members" slot-scope="props">
						<ul class="members-list">
							<li class="members-list-item" v-for="(member, key) in props.rowData.members" :key="key">
								{{ member.last_name + ' ' + member.first_name + ' ' + member.middle_name }}
								<p class="members-list-item__info">
									<span class="badge badge-pill badge-dark" v-if="member.packet_type === 1">Стандарт</span>
									<span class="badge badge-pill badge-success bg-blue" v-if="member.packet_type === 2">Бизнес</span>
									<span class="badge badge-pill badge-primary bg-pink" v-if="member.packet_type === 3">VIP</span>
									<a v-if="member.email !== ''" :href="'mailto:' + member.email">({{ member.email }})</a></p>
							</li>
						</ul>
					</template>
					<template slot="amount" slot-scope="props">
						{{ props.rowData.amount | currency}}
					</template>
					<template slot="watcher" slot-scope="props">
						<b-button v-if="props.rowData.watcher === 0" @click="actionWatcherHandler(props.rowIndex, props.rowData.id)"><i class="icon-check icons"></i></b-button>
						<b-button variant="success" v-if="props.rowData.watcher === 1" @click="actionWatcherHandler(props.rowIndex, props.rowData.id)"><i class="icon-check icons"></i></b-button>
					</template>
					<template slot="comment" slot-scope="props">
						<text-to-textarea v-if="loading" :index="props.rowIndex" :text="props.rowData.comment" @focusout="actionWatcherCommentHandler"></text-to-textarea>
					</template>
					<template slot="actions" slot-scope="props">
						<b-dropdown variant="primary" class="">
							<template slot="button-content"><i class="icon-settings"></i></template>
							<b-dropdown-item @click="actionDownloadAgreementHandler(props.rowData.id)"><i class="icon-cloud-download"></i>Скачать договор</b-dropdown-item>
							<b-dropdown-item @click="actionDownloadActHandler(props.rowData.id)"><i class="icon-cloud-download"></i>Скачать акт</b-dropdown-item>
							<b-dropdown-item @click="actionSendEmailActHandler(props.rowIndex)"><i class="icon-envelope"></i>Отправить на почту</b-dropdown-item>
							<b-dropdown-item @click="actionSendNotification(props.rowIndex)"><i class="icon-bell"></i>Написать ответственному</b-dropdown-item>
						</b-dropdown>
					</template>
				</vuetable>
				<vuetable-pagination
					ref="pagination"
					:css="css.pagination"
					@vuetable-pagination:change-page="onChangePage"
				></vuetable-pagination>
			</b-tab>
		</b-tabs>
		<b-modal v-model="sendEmailModal" @hidden="hideHandler" @ok="sendHandler" size="lg" cancel-title="Отмена" ok-title="Отправить" title="Отправка документов">
			<custom-send-form
				ref="docsSend"
				v-if="sendEmailModal"
				:amount="amount"
				:emails="emails"
				:members="members"
			></custom-send-form>
		</b-modal>
		<b-modal v-model="sendNotificationModal" @hidden="modalNotificationHide" @ok="modalNotificationSend" size="lg" cancel-title="Отмена" ok-title="Отправить" title="Отправить уведомление ответственному">
			<b-form ref="form">
				<div class="row">
					<div class="col-md-12">
						<table class="table table-responsive-sm table-bordered table-striped table-sm">
							<thead>
								<tr>
									<th>ID платежа</th>
									<th>Ответственный</th>
								</tr>
							</thead>
							<tbody>
								<tr>
									<td>{{ notification.id }}</td>
									<td>{{ notification.manager}}</td>
								</tr>
							</tbody>
						</table>
						<b-form-group label="Текст сообщения" label-for="notification" class="is-required" :class="{ 'has-error': $v.notification.text.$error }">
							<b-form-textarea rows="3" id="notification" v-model.trim="notification.text"></b-form-textarea>
						</b-form-group>
					</div>
				</div>
			</b-form>
		</b-modal>
	</div>
</template>
<script>
import moment from 'moment'
import { required } from 'vuelidate/lib/validators'
import Loading from 'vue-loading-overlay'
import fileBlob from '@/libs/file/fileBlob'
import TextToTextarea from '@/components/ui/text-to-textarea'
import eventPaymentAPI from '@/api/modules/event/payment'
import documentAgreementAPI from '@/api/modules/document/agreement'
import documentActAPI from '@/api/modules/document/act'
import documentEmailAPI from '@/api/modules/document/email'
import documentWatcherAPI from '@/api/modules/document/watcher'
import paymentIssueHTTP from '@/api/modules/payment/issue'
import eventExportHTTP from '@/api/modules/event/export'
import documentWatcherCommentAPI from '@/api/modules/document/comment'
import CustomSendForm from '@/components/payment/docs/custom-send-form'
import ProductMemberFilter from '../../../components/product/ProductMemberFilter.vue'
// import memberAPI from '@/api/modules/event/member'
export default {
	components: {
		Loading,
		TextToTextarea,
		CustomSendForm,
		'product-member-filter': ProductMemberFilter
	},
	data () {
		return {
			loading: false,
			isFilterOpen: false,
			id: null,
			sendEmailModal: false,
			sendNotificationModal: false,
			currentPageNumber: 0,
			activeTab: 0,
			tabs: {
				0: 'view',
				1: 'members'
			},
			notification: {
				id: '',
				text: '',
				manager: ''
			},
			rowId: null,
			amount: null,
			emails: [],
			members: [],
			tableData: [],
			totalPayments: 0,
			totalMembers: 0,
			counter: {
				vip: 0,
				business: 0,
				standard: 0
			},
			filterParams: {},
			columns: [
				{
					name: '__slot:id',
					title: 'ID'
				}, {
					name: '__slot:bitrix_deal_id',
					title: 'ID сделки (Bitrix24)'
				}, {
					name: '__slot:bitrix_company_id',
					title: 'ID компании (Bitrix24)'
				}, {
					name: 'bitrix.company_title',
					title: 'Название компании'
				}, {
					name: '__slot:manager',
					title: 'Менеджер'
				}, {
					name: '__slot:members',
					title: 'Участники'
				}, {
					name: '__slot:amount',
					title: 'Сумма'
				}, {
					name: '__slot:watcher',
					title: 'Памятка'
				}, {
					name: '__slot:comment',
					title: 'Комментарий'
				}, {
					name: '__slot:actions',
					title: 'Действия'
				}
			],
			css: {
				pagination: {
					wrapperClass: 'pagination float-right',
					activeClass: 'active',
					disabledClass: 'disabled',
					pageClass: 'page-item',
					linkClass: 'page-link',
					paginationClass: 'pagination',
					paginationInfoClass: 'float-left',
					dropdownClass: 'form-control',
					icons: {
						first: 'fa fa-chevron-left',
						prev: 'fa fa-chevron-left',
						next: 'fa fa-chevron-right',
						last: 'fa fa-chevron-right'
					}
				}
			}
		}
	},
	props: {
		data: {
			type: Object,
			default: null
		}
	},
	validations: {
		notification: {
			text: {
				required
			}
		}
	},
	created () {
		this.id = parseInt(this.$route.params.id)
		this.getMembers()
		this.setTitle()
		// this.$store.commit('FUNNY_PROGRESS_ON')
	},
	methods: {
		getMembers: function (params = {}) {
			const queryParams = {
				event_id: this.id,
				expand: 'manager,members,watcher,comment'
			}

			Object.assign(queryParams, params)

			if (this.currentPageNumber > 0) {
				queryParams['page'] = this.currentPageNumber
			}

			const filterParams = this.filterParams
			for (let key in filterParams) {
				if (filterParams[key]) {
					if (!queryParams.hasOwnProperty('filter')) {
						queryParams['filter'] = {}
					}

					queryParams['filter'][key] = filterParams[key]
				}
			}

			eventPaymentAPI.findAll(queryParams).then((response) => {
				this.tableData = response
				this.totalMembers = this.tableData.params.total_members
				this.counter.standard = this.tableData.params.total_standard
				this.counter.business = this.tableData.params.total_business
				this.counter.vip = this.tableData.params.total_vip
				this.setTitle()
				this.loading = false
				setTimeout(() => {
					this.loading = true
				}, 500)
			}, function (response) {
				this.loading = true
			})
		},
		dateFormat: function (date) {
			return moment(date).format('DD.MM.Y')
		},
		rowClickHandler (dataItem, field, event) {
			// this.$router.push({path: `/events/${dataItem.id}/view`})
		},
		onPaginationData (paginationData) {
			this.$refs.pagination.setPaginationData(paginationData)
		},
		onChangePage (page) {
			this.currentPageNumber = page
			this.getMembers({page: page})
			this.$refs.vuetable.changePage(page)
		},
		actionExport () {
			eventExportHTTP.findOne(this.id).then((response) => {
				fileBlob.get(response).then((link) => {
					link.click()
				})
			}, (response) => {
				this.$notify({
					group: 'default',
					type: 'danger',
					duration: -1,
					text: response.body.message
				})
			})
		},
		onToggleFilter () {
			this.isFilterOpen = !this.isFilterOpen
		},
		actionDownloadAgreementHandler (id) {
			const params = {
				type: 'event'
			}

			documentAgreementAPI.findOne(id, params).then((response) => {
				fileBlob.get(response).then((link) => {
					link.click()
				})
			}, (response) => {
				this.$notify({
					group: 'default',
					type: 'danger',
					text: response.body.message
				})
			})
		},
		actionDownloadActHandler (id) {
			const params = {
				type: 'event'
			}
			documentActAPI.findOne(id, params).then((response) => {
				fileBlob.get(response).then((link) => {
					link.click()
				})
			}, (response) => {
				this.$notify({
					group: 'default',
					type: 'danger',
					text: response.body.message
				})
			})
		},
		actionSendEmailActHandler (index) {
			this.emails = []
			this.rowId = this.tableData.data[index].id
			this.amount = parseFloat(this.tableData.data[index].amount)
			let members = this.tableData.data[index].members
			this.members = members
			members.forEach((value, id) => {
				this.emails.push({key: value.email, value: value.email})
			})
			this.sendEmailModal = true
		},
		actionWatcherHandler (index, id) {
			const data = {
				payment_id: id
			}
			this.tableData.data[index].watcher === 0 ? this.tableData.data[index].watcher = 1 : this.tableData.data[index].watcher = 0
			documentWatcherAPI.create(data).then((response) => {
				this.$notify({
					group: 'success',
					type: 'success',
					text: 'Статус памятки обновлён.'
				})
			})
		},
		actionWatcherCommentHandler (params) {
			const data = {
				payment_id: this.tableData.data[params.index].id,
				text: params.string
			}
			documentWatcherCommentAPI.create(data).then((response) => {
				this.$notify({
					group: 'success',
					type: 'success',
					text: 'Комментарий обновлён.'
				})
			})
		},
		actionSendNotification (index) {
			const payment = this.tableData.data[index]
			this.notification.id = payment.id
			this.notification.manager = payment.manager.first_name + ' ' + payment.manager.last_name
			this.notification.payment = payment
			this.sendNotificationModal = true
		},
		sendHandler (e) {
			// prevent default
			e.preventDefault()
			// define variables and constants
			let _emails = []
			let _members = []
			const rowId = this.rowId
			let data = this.$refs.docsSend.getData()
			console.log(data)
			if (data.emails.length === 0) {
				return false
			}

			data.emails.forEach((value, key) => {
				_emails.push(value.value)
			})

			data.members.forEach((value, key) => {
				_members.push({
					first_name: value.first_name,
					last_name: value.last_name,
					middle_name: value.middle_name,
					packet_type: value.packet_type
				})
			})

			const _data = {
				id: rowId,
				custom: data.extra === true ? 1 : 0,
				amount: data.amount,
				emails: _emails.join(','),
				members: _members
			}

			documentEmailAPI.create(_data).then((response) => {
				this.sendEmailModal = false
				this.form = {}
				this.$notify({
					group: 'default',
					title: 'Поздравляем!',
					text: 'Документы отправлены.'
				})
			}).catch((response) => {
				this.$notify({
					group: 'default',
					type: 'danger',
					text: response.body.message
				})
			})
		},
		hideHandler () {
			this.form = {}
		},
		onSendFilterForm (values) {
			this.filterParams = values
			/*
			const params = {}
			for (let key in values) {
				if (values[key]) {
					params[key] = values[key]
				}
			}

			if (this.currentPageNumber > 0) {
				params['page'] = this.currentPageNumber
			}
			*/
			this.getMembers()
		},
		modalNotificationSend (e) {
			e.preventDefault()
			this.$v.$touch()
			if (this.$v.notification.$invalid) {
				return false
			}
			const data = {
				payment_id: this.notification.id,
				receiver_id: this.notification.payment.manager_id,
				path: this.$route.path,
				text: this.notification.text
			}
			paymentIssueHTTP.create(data).then((response) => {
				this.sendNotificationModal = false
				this.form = {}
				this.$notify({
					group: 'default',
					title: 'Поздравляем!',
					text: 'Уведомление отправлено.'
				})
			})
		},
		modalNotificationHide () {
			this.$v.notification.$reset()
			this.notification = {}
		},
		setTitle () {
			document.title = 'Участники' + ' | ' + this.data.product.title
		}
	},
	watch: {
		activeTab: function (value) {
			this.$router.push({path: '/events/' + this.id + '/' + this.tabs[value]})
		}
	}
}
</script>
<style lang="scss" scope>
.filter-visibility-trigger {
	padding-right: 1.5rem;
	&:after {
		content: '';
		position: absolute;
		top: 50%;
    right: 0.5rem;
		margin-top: -2.5px;
		border-left: 5px solid transparent;
    border-right: 5px solid transparent;
    border-top: 5px solid var(--white);
	}
	&.open {
		&:after {
			border-top: none;
			border-bottom: 5px solid var(--white);
		}
	}
}

.event-members {
	.members-list {
		padding: 0;
		margin: 0;
		line-height: 1.5;
		list-style: none;
		.members-list-item {
			margin-bottom: 7px;
			&:last-child { margin-bottom: 0; }
			.members-list-item__info {
				font-size: 12px;
				.badge {
					padding: 0.25em 0.5em;
					text-transform: lowercase;
				}
			}
		}
	}
}

.vue-tags-input {
	max-width: 100% !important;
}
</style>



// WEBPACK FOOTER //
// src/pages/event/viewTabs/index.vue